import { Tooltip, TooltipPosition } from 'components/tooltip';

import { ChangeEvent } from 'react';
import { IppicaTodayFilterType } from 'features/ippica/types';
import { RadioButton } from 'components/inputs/radioButton';
import styles from './IppicaFiltersDialogRow.module.scss';
import useWindowSize from 'hooks/useWindowSize';

export type IppicaFiltersDialogRowProps = {
  indexRow: number;
  todayFilter: IppicaTodayFilterType;
  defaultFilter: { label: string };
  handleRadioChange: (e: ChangeEvent<HTMLInputElement>, list: IppicaTodayFilterType['values'], index: number) => void;
};
export const IppicaFiltersDialogRow = ({
  indexRow,
  todayFilter,
  defaultFilter,
  handleRadioChange,
}: IppicaFiltersDialogRowProps) => {
  const { isMobile } = useWindowSize();

  return (
    <div className={`${styles.container} ${todayFilter.typeOfItem === 'toggle' ? styles.horizontal : ''}`}>
      <div className={`${styles.paragraph} ${todayFilter.typeOfItem === 'toggle' ? styles.noMargin : ''}`}>
        <span className={`${styles.label} ${todayFilter?.tooltipContent ? styles.withRightMargin : ''}`}>
          {todayFilter.label}
        </span>
        {todayFilter?.tooltipContent && (
          <Tooltip content={todayFilter.tooltipContent} position={TooltipPosition.RIGHT}></Tooltip>
        )}
      </div>
      <div className={`${styles.valuesContainer} ${styles[todayFilter.typeOfItem]}`}>
        <RadioButton
          isVertical={isMobile}
          name={todayFilter.label}
          options={todayFilter.values.map((item) => {
            return { label: item.label, value: item.label };
          })}
          onChange={(e) => handleRadioChange(e, todayFilter.values, indexRow)}
          defaultValue={defaultFilter.label}
          className={todayFilter.typeOfItem !== 'toggle' ? styles.radio : styles.toggle}
        />
      </div>
    </div>
  );
};
